import styled from 'styled-components'

const Image = styled.img`
max-height: 50%;
max-width: 50%;
`

export default Image
